export default "__VITE_ASSET__03dd4c56__"